<script>
import Badge from "../Content/Badge.vue";;
import icon from "../../mixins/icon";

export default {
    name: "Badges",
    components: {Badge},

    props: {
        badges: {
            type: Array,
            required: true,
        },
        alternative: {
            type: Boolean,
            default: false,
        },
        hasTitle: {
            type: Boolean,
            default: false,
        }
    },

    mixins: [icon],
}
</script>

<template>
    <div class="vue-badges" :class="{'has-title': hasTitle}">
        <div v-if="hasTitle" class="is-title">
            Beschikbaar in:
        </div>
        <ul class="badges">
            <li v-for="badge in badges">
                <Badge :label="badge.label" :alternative="alternative">
                    <component :is="getIcon(badge.id)" />
                </Badge>
            </li>
        </ul>
    </div>
</template>
